import Joi from 'joi';

const PayloadTypeIndicator = Joi.string().allow('');

export default PayloadTypeIndicator;
